import { createStore } from "@stencil/store";
import { Category, Product } from "../api/responses/get-search-response";
import { SearchResponse } from "../api/responses/get-search-response";
import config from "../environment/environment-config";

const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

const searchUrl = config.apiUrls.searchApi;
// TT custom - categories
interface SearchStore {
  searchOpen: boolean;
  products: Array<Product>;
  categories: Array<Category>;
  searchTerm: string;
  total: number;
  errors: string[];
}

const { state, onChange } = createStore({
  searchOpen: false,
  products: [],
  categories: [],
  searchTerm: "",
  total: 0,
  errors: [],
} as SearchStore);

let getSearchResultsAbortController;

onChange("searchTerm", (searchTerm) => {
  if (searchTerm) {
    getSearchResultsAbortController = new AbortController();
    getSearchResults(searchTerm);
  } else {
    state.products = [];
    getSearchResultsAbortController?.abort();
  }
});

export const getSearchResults: (searchTerm: string) => void = async (
  searchTerm
) => {
  return fetch(`${searchUrl}?term=${searchTerm}`, {
    method: "GET",
    headers,
    signal: getSearchResultsAbortController.signal,
  })
    .then(async (response) => {
      if (!response.ok) {
        // TODO: handle error here
      }
      const searchResult: SearchResponse = await response.json();
      // TT Custom start
      state.products = searchResult?.products ?? [];
      state.categories = searchResult?.categories ?? [];
      // TT Custom end
    })
    .catch(handleErrors);
};

const handleErrors = async (error) => {
  console.error(error);
};

export default state;
